import { render } from "./Dialog.vue?vue&type=template&id=4853dcaf&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&id=4853dcaf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4853dcaf"

export default script